import React from 'react';
import './ScollIndicator.css';
import PropTypes from 'prop-types';
import { HashLink } from "react-router-hash-link";


const ScrollIndicator = ({ to }) => (
  <HashLink smooth to={to} className="scroll-indicator">
    <div className="scroll-wheel"></div>
  </HashLink>
);


ScrollIndicator.propTypes = {
  to: PropTypes.string
};

export default ScrollIndicator;



// WEBPACK FOOTER //
// ./src/components/common/ScrollIndicator/ScrollIndicator.js